import { j as E } from "../../jsx-runtime-82a9ddf6.js";
import V, { createContext as ut, useState as b, useRef as z, useEffect as m, useContext as dt, useCallback as pt, useLayoutEffect as ft } from "react";
import { CopyIcon as We } from "../icons/icons/CopyIcon.js";
import { cva as yt } from "../../lib/cn.js";
import { a as mt, b as vt, c as Je, o as wt, f as bt, s as ht } from "../../floating-ui.dom-83d6130b.js";
import { r as Qe } from "../../index-64728d0d.js";
import { useMobile as gt } from "../../hooks/useMobile/index.js";
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const _t = "react-tooltip-core-styles", St = "react-tooltip-base-styles", Xe = { core: !1, base: !1 };
function Fe({ css: e, id: t = St, type: o = "base", ref: r }) {
  var i, c;
  if (!e || typeof document > "u" || Xe[o] || o === "core" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_CORE_STYLES) || o !== "base" && typeof process < "u" && (!((c = process == null ? void 0 : process.env) === null || c === void 0) && c.REACT_TOOLTIP_DISABLE_BASE_STYLES))
    return;
  o === "core" && (t = _t), r || (r = {});
  const { insertAt: y } = r;
  if (document.getElementById(t))
    return void console.warn(`[react-tooltip] Element with id '${t}' already exists. Call \`removeStyle()\` first`);
  const a = document.head || document.getElementsByTagName("head")[0], d = document.createElement("style");
  d.id = t, d.type = "text/css", y === "top" && a.firstChild ? a.insertBefore(d, a.firstChild) : a.appendChild(d), d.styleSheet ? d.styleSheet.cssText = e : d.appendChild(document.createTextNode(e)), Xe[o] = !0;
}
const qe = (e, t, o) => {
  let r = null;
  return function(...i) {
    const c = () => {
      r = null, o || e.apply(this, i);
    };
    o && !r && (e.apply(this, i), r = setTimeout(c, t)), o || (r && clearTimeout(r), r = setTimeout(c, t));
  };
}, Ot = "DEFAULT_TOOLTIP_ID", Ct = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, Et = ut({ getTooltipData: () => Ct });
function lt(e = Ot) {
  return dt(Et).getTooltipData(e);
}
const Tt = typeof window < "u" ? ft : m, xt = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement))
    return !1;
  const t = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((o) => {
    const r = t.getPropertyValue(o);
    return r === "auto" || r === "scroll";
  });
}, Ke = (e) => {
  if (!e)
    return null;
  let t = e.parentElement;
  for (; t; ) {
    if (xt(t))
      return t;
    t = t.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, Ve = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: o = null, place: r = "top", offset: i = 10, strategy: c = "absolute", middlewares: y = [wt(Number(i)), bt(), ht({ padding: 5 })], border: a }) => {
  if (!e)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  if (t === null)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  const d = y;
  return o ? (d.push(vt({ element: o, padding: 5 })), Je(e, t, { placement: r, strategy: c, middleware: d }).then(({ x: w, y: p, placement: v, middlewareData: x }) => {
    var _, h;
    const j = { left: `${w}px`, top: `${p}px`, border: a }, { x: B, y: M } = (_ = x.arrow) !== null && _ !== void 0 ? _ : { x: 0, y: 0 }, A = (h = { top: "bottom", right: "left", bottom: "top", left: "right" }[v.split("-")[0]]) !== null && h !== void 0 ? h : "bottom", g = a && { borderBottom: a, borderRight: a };
    let D = 0;
    if (a) {
      const $ = `${a}`.match(/(\d+)px/);
      D = $ != null && $[1] ? Number($[1]) : 1;
    }
    return { tooltipStyles: j, tooltipArrowStyles: { left: B != null ? `${B}px` : "", top: M != null ? `${M}px` : "", right: "", bottom: "", ...g, [A]: `-${4 + D}px` }, place: v };
  })) : Je(e, t, { placement: "bottom", strategy: c, middleware: d }).then(({ x: w, y: p, placement: v }) => ({ tooltipStyles: { left: `${w}px`, top: `${p}px` }, tooltipArrowStyles: {}, place: v }));
};
var At = "core-styles-module_tooltip__3vRRp", It = "core-styles-module_fixed__pcSol", jt = "core-styles-module_arrow__cvMwQ", Lt = "core-styles-module_noArrow__xock6", Mt = "core-styles-module_clickable__ZuTTB", Nt = "core-styles-module_show__Nt9eE", He = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const Dt = ({ id: e, className: t, classNameArrow: o, variant: r = "dark", anchorId: i, anchorSelect: c, place: y = "top", offset: a = 10, events: d = ["hover"], openOnClick: w = !1, positionStrategy: p = "absolute", middlewares: v, wrapper: x, delayShow: _ = 0, delayHide: h = 0, float: j = !1, hidden: B = !1, noArrow: M = !1, clickable: A = !1, closeOnEsc: g = !1, closeOnScroll: D = !1, closeOnResize: $ = !1, style: be, position: ne, afterShow: he, afterHide: ge, content: R, contentWrapperRef: X, isOpen: F, setIsOpen: Y, activeAnchor: S, setActiveAnchor: W, border: _e, opacity: Se, arrowColor: Oe }) => {
  const I = z(null), Z = z(null), T = z(null), L = z(null), [Ce, Ee] = b(y), [le, Te] = b({}), [xe, Ae] = b({}), [N, Ie] = b(!1), [ie, ee] = b(!1), ae = z(!1), ce = z(null), { anchorRefs: se, setActiveAnchor: je } = lt(e), te = z(!1), [U, ue] = b([]), q = z(!1), re = w || d.includes("click");
  Tt(() => (q.current = !0, () => {
    q.current = !1;
  }), []), m(() => {
    if (!N) {
      const l = setTimeout(() => {
        ee(!1);
      }, 150);
      return () => {
        clearTimeout(l);
      };
    }
    return () => null;
  }, [N]);
  const k = (l) => {
    q.current && (l && ee(!0), setTimeout(() => {
      q.current && (Y == null || Y(l), F === void 0 && Ie(l));
    }, 10));
  };
  m(() => {
    if (F === void 0)
      return () => null;
    F && ee(!0);
    const l = setTimeout(() => {
      Ie(F);
    }, 10);
    return () => {
      clearTimeout(l);
    };
  }, [F]), m(() => {
    N !== ae.current && (ae.current = N, N ? he == null || he() : ge == null || ge());
  }, [N]);
  const oe = (l = h) => {
    L.current && clearTimeout(L.current), L.current = setTimeout(() => {
      te.current || k(!1);
    }, l);
  }, J = (l) => {
    var s;
    if (!l)
      return;
    const n = (s = l.currentTarget) !== null && s !== void 0 ? s : l.target;
    if (!(n != null && n.isConnected))
      return W(null), void je({ current: null });
    _ ? (T.current && clearTimeout(T.current), T.current = setTimeout(() => {
      k(!0);
    }, _)) : k(!0), W(n), je({ current: n }), L.current && clearTimeout(L.current);
  }, Le = () => {
    A ? oe(h || 100) : h ? oe() : k(!1), T.current && clearTimeout(T.current);
  }, de = ({ x: l, y: s }) => {
    Ve({ place: y, offset: a, elementReference: { getBoundingClientRect: () => ({ x: l, y: s, width: 0, height: 0, top: s, left: l, right: l, bottom: s }) }, tooltipReference: I.current, tooltipArrowReference: Z.current, strategy: p, middlewares: v, border: _e }).then((n) => {
      Object.keys(n.tooltipStyles).length && Te(n.tooltipStyles), Object.keys(n.tooltipArrowStyles).length && Ae(n.tooltipArrowStyles), Ee(n.place);
    });
  }, Me = (l) => {
    if (!l)
      return;
    const s = l, n = { x: s.clientX, y: s.clientY };
    de(n), ce.current = n;
  }, Ne = (l) => {
    J(l), h && oe();
  }, pe = (l) => {
    var s;
    [document.querySelector(`[id='${i}']`), ...U].some((n) => n == null ? void 0 : n.contains(l.target)) || !((s = I.current) === null || s === void 0) && s.contains(l.target) || (k(!1), T.current && clearTimeout(T.current));
  }, fe = qe(J, 50, !0), K = qe(Le, 50, !0), Q = pt(() => {
    ne ? de(ne) : j ? ce.current && de(ce.current) : Ve({ place: y, offset: a, elementReference: S, tooltipReference: I.current, tooltipArrowReference: Z.current, strategy: p, middlewares: v, border: _e }).then((l) => {
      q.current && (Object.keys(l.tooltipStyles).length && Te(l.tooltipStyles), Object.keys(l.tooltipArrowStyles).length && Ae(l.tooltipArrowStyles), Ee(l.place));
    });
  }, [N, S, R, be, y, a, p, ne, j]);
  m(() => {
    var l, s;
    const n = new Set(se);
    U.forEach((G) => {
      n.add({ current: G });
    });
    const u = document.querySelector(`[id='${i}']`);
    u && n.add({ current: u });
    const f = () => {
      k(!1);
    }, C = Ke(S), O = Ke(I.current);
    D && (window.addEventListener("scroll", f), C == null || C.addEventListener("scroll", f), O == null || O.addEventListener("scroll", f));
    let P = null;
    $ ? window.addEventListener("resize", f) : S && I.current && (P = mt(S, I.current, Q, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const me = (G) => {
      G.key === "Escape" && k(!1);
    };
    g && window.addEventListener("keydown", me);
    const H = [];
    re ? (window.addEventListener("click", pe), H.push({ event: "click", listener: Ne })) : (H.push({ event: "mouseenter", listener: fe }, { event: "mouseleave", listener: K }, { event: "focus", listener: fe }, { event: "blur", listener: K }), j && H.push({ event: "mousemove", listener: Me }));
    const De = () => {
      te.current = !0;
    }, Ue = () => {
      te.current = !1, Le();
    };
    return A && !re && ((l = I.current) === null || l === void 0 || l.addEventListener("mouseenter", De), (s = I.current) === null || s === void 0 || s.addEventListener("mouseleave", Ue)), H.forEach(({ event: G, listener: ve }) => {
      n.forEach((ze) => {
        var we;
        (we = ze.current) === null || we === void 0 || we.addEventListener(G, ve);
      });
    }), () => {
      var G, ve;
      D && (window.removeEventListener("scroll", f), C == null || C.removeEventListener("scroll", f), O == null || O.removeEventListener("scroll", f)), $ ? window.removeEventListener("resize", f) : P == null || P(), re && window.removeEventListener("click", pe), g && window.removeEventListener("keydown", me), A && !re && ((G = I.current) === null || G === void 0 || G.removeEventListener("mouseenter", De), (ve = I.current) === null || ve === void 0 || ve.removeEventListener("mouseleave", Ue)), H.forEach(({ event: ze, listener: we }) => {
        n.forEach((st) => {
          var Be;
          (Be = st.current) === null || Be === void 0 || Be.removeEventListener(ze, we);
        });
      });
    };
  }, [S, Q, ie, se, U, g, d]), m(() => {
    let l = c ?? "";
    !l && e && (l = `[data-tooltip-id='${e}']`);
    const s = new MutationObserver((n) => {
      const u = [];
      n.forEach((f) => {
        if (f.type === "attributes" && f.attributeName === "data-tooltip-id" && f.target.getAttribute("data-tooltip-id") === e && u.push(f.target), f.type === "childList" && (S && [...f.removedNodes].some((C) => {
          var O;
          return !!(!((O = C == null ? void 0 : C.contains) === null || O === void 0) && O.call(C, S)) && (ee(!1), k(!1), W(null), T.current && clearTimeout(T.current), L.current && clearTimeout(L.current), !0);
        }), l))
          try {
            const C = [...f.addedNodes].filter((O) => O.nodeType === 1);
            u.push(...C.filter((O) => O.matches(l))), u.push(...C.flatMap((O) => [...O.querySelectorAll(l)]));
          } catch {
          }
      }), u.length && ue((f) => [...f, ...u]);
    });
    return s.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"] }), () => {
      s.disconnect();
    };
  }, [e, c, S]), m(() => {
    Q();
  }, [Q]), m(() => {
    if (!(X != null && X.current))
      return () => null;
    const l = new ResizeObserver(() => {
      Q();
    });
    return l.observe(X.current), () => {
      l.disconnect();
    };
  }, [R, X == null ? void 0 : X.current]), m(() => {
    var l;
    const s = document.querySelector(`[id='${i}']`), n = [...U, s];
    S && n.includes(S) || W((l = U[0]) !== null && l !== void 0 ? l : s);
  }, [i, U, S]), m(() => () => {
    T.current && clearTimeout(T.current), L.current && clearTimeout(L.current);
  }, []), m(() => {
    let l = c;
    if (!l && e && (l = `[data-tooltip-id='${e}']`), l)
      try {
        const s = Array.from(document.querySelectorAll(l));
        ue(s);
      } catch {
        ue([]);
      }
  }, [e, c]);
  const ye = !B && R && N && Object.keys(le).length > 0;
  return ie ? V.createElement(x, { id: e, role: "tooltip", className: Qe("react-tooltip", At, He.tooltip, He[r], t, `react-tooltip__place-${Ce}`, { "react-tooltip__show": ye, [Nt]: ye, [It]: p === "fixed", [Mt]: A }), style: { ...be, ...le, opacity: Se !== void 0 && ye ? Se : void 0 }, ref: I }, R, V.createElement(x, { className: Qe("react-tooltip-arrow", jt, He.arrow, o, { [Lt]: M }), style: { ...xe, background: Oe ? `linear-gradient(to right bottom, transparent 50%, ${Oe} 50%)` : void 0 }, ref: Z })) : null;
}, Rt = ({ content: e }) => V.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), kt = ({ id: e, anchorId: t, anchorSelect: o, content: r, html: i, render: c, className: y, classNameArrow: a, variant: d = "dark", place: w = "top", offset: p = 10, wrapper: v = "div", children: x = null, events: _ = ["hover"], openOnClick: h = !1, positionStrategy: j = "absolute", middlewares: B, delayShow: M = 0, delayHide: A = 0, float: g = !1, hidden: D = !1, noArrow: $ = !1, clickable: be = !1, closeOnEsc: ne = !1, closeOnScroll: he = !1, closeOnResize: ge = !1, style: R, position: X, isOpen: F, disableStyleInjection: Y = !1, border: S, opacity: W, arrowColor: _e, setIsOpen: Se, afterShow: Oe, afterHide: I }) => {
  const [Z, T] = b(r), [L, Ce] = b(i), [Ee, le] = b(w), [Te, xe] = b(d), [Ae, N] = b(p), [Ie, ie] = b(M), [ee, ae] = b(A), [ce, se] = b(g), [je, te] = b(D), [U, ue] = b(v), [q, re] = b(_), [k, oe] = b(j), [J, Le] = b(null), de = z(Y), { anchorRefs: Me, activeAnchor: Ne } = lt(e), pe = (l) => l == null ? void 0 : l.getAttributeNames().reduce((s, n) => {
    var u;
    return n.startsWith("data-tooltip-") && (s[n.replace(/^data-tooltip-/, "")] = (u = l == null ? void 0 : l.getAttribute(n)) !== null && u !== void 0 ? u : null), s;
  }, {}), fe = (l) => {
    const s = { place: (n) => {
      var u;
      le((u = n) !== null && u !== void 0 ? u : w);
    }, content: (n) => {
      T(n ?? r);
    }, html: (n) => {
      Ce(n ?? i);
    }, variant: (n) => {
      var u;
      xe((u = n) !== null && u !== void 0 ? u : d);
    }, offset: (n) => {
      N(n === null ? p : Number(n));
    }, wrapper: (n) => {
      var u;
      ue((u = n) !== null && u !== void 0 ? u : v);
    }, events: (n) => {
      const u = n == null ? void 0 : n.split(" ");
      re(u ?? _);
    }, "position-strategy": (n) => {
      var u;
      oe((u = n) !== null && u !== void 0 ? u : j);
    }, "delay-show": (n) => {
      ie(n === null ? M : Number(n));
    }, "delay-hide": (n) => {
      ae(n === null ? A : Number(n));
    }, float: (n) => {
      se(n === null ? g : n === "true");
    }, hidden: (n) => {
      te(n === null ? D : n === "true");
    } };
    Object.values(s).forEach((n) => n(null)), Object.entries(l).forEach(([n, u]) => {
      var f;
      (f = s[n]) === null || f === void 0 || f.call(s, u);
    });
  };
  m(() => {
    T(r);
  }, [r]), m(() => {
    Ce(i);
  }, [i]), m(() => {
    le(w);
  }, [w]), m(() => {
    xe(d);
  }, [d]), m(() => {
    N(p);
  }, [p]), m(() => {
    ie(M);
  }, [M]), m(() => {
    ae(A);
  }, [A]), m(() => {
    se(g);
  }, [g]), m(() => {
    te(D);
  }, [D]), m(() => {
    oe(j);
  }, [j]), m(() => {
    de.current !== Y && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [Y]), m(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: Y === "core", disableBase: Y } }));
  }, []), m(() => {
    var l;
    const s = new Set(Me);
    let n = o;
    if (!n && e && (n = `[data-tooltip-id='${e}']`), n)
      try {
        document.querySelectorAll(n).forEach((P) => {
          s.add({ current: P });
        });
      } catch {
        console.warn(`[react-tooltip] "${n}" is not a valid CSS selector`);
      }
    const u = document.querySelector(`[id='${t}']`);
    if (u && s.add({ current: u }), !s.size)
      return () => null;
    const f = (l = J ?? u) !== null && l !== void 0 ? l : Ne.current, C = new MutationObserver((P) => {
      P.forEach((me) => {
        var H;
        if (!f || me.type !== "attributes" || !(!((H = me.attributeName) === null || H === void 0) && H.startsWith("data-tooltip-")))
          return;
        const De = pe(f);
        fe(De);
      });
    }), O = { attributes: !0, childList: !1, subtree: !1 };
    if (f) {
      const P = pe(f);
      fe(P), C.observe(f, O);
    }
    return () => {
      C.disconnect();
    };
  }, [Me, Ne, J, t, o]), m(() => {
    R != null && R.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), S && !CSS.supports("border", `${S}`) && console.warn(`[react-tooltip] "${S}" is not a valid \`border\`.`), R != null && R.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), W && !CSS.supports("opacity", `${W}`) && console.warn(`[react-tooltip] "${W}" is not a valid \`opacity\`.`);
  }, []);
  let K = x;
  const Q = z(null);
  if (c) {
    const l = c({ content: Z ?? null, activeAnchor: J });
    K = l ? V.createElement("div", { ref: Q, className: "react-tooltip-content-wrapper" }, l) : null;
  } else
    Z && (K = Z);
  L && (K = V.createElement(Rt, { content: L }));
  const ye = { id: e, anchorId: t, anchorSelect: o, className: y, classNameArrow: a, content: K, contentWrapperRef: Q, place: Ee, variant: Te, offset: Ae, wrapper: U, events: q, openOnClick: h, positionStrategy: k, middlewares: B, delayShow: Ie, delayHide: ee, float: ce, hidden: je, noArrow: $, clickable: be, closeOnEsc: ne, closeOnScroll: he, closeOnResize: ge, style: R, position: X, isOpen: F, border: S, opacity: W, arrowColor: _e, setIsOpen: Se, afterShow: Oe, afterHide: I, activeAnchor: J, setActiveAnchor: (l) => Le(l) };
  return V.createElement(Dt, { ...ye });
};
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || Fe({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9}.core-styles-module_tooltip__3vRRp{visibility:hidden;position:absolute;top:0;left:0;pointer-events:none;opacity:0;transition:opacity 0.3s ease-out;will-change:opacity,visibility}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{visibility:visible;opacity:var(--rt-opacity)}", type: "core" }), e.detail.disableBase || Fe({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
var Pe = {}, Pt = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, o = [], r = 0; r < e.rangeCount; r++)
    o.push(e.getRangeAt(r));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || o.forEach(function(i) {
      e.addRange(i);
    }), t && t.focus();
  };
}, zt = Pt, et = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, Bt = "Copy to clipboard: #{key}, Enter";
function Wt(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function Ht(e, t) {
  var o, r, i, c, y, a, d = !1;
  t || (t = {}), o = t.debug || !1;
  try {
    i = zt(), c = document.createRange(), y = document.getSelection(), a = document.createElement("span"), a.textContent = e, a.ariaHidden = "true", a.style.all = "unset", a.style.position = "fixed", a.style.top = 0, a.style.clip = "rect(0, 0, 0, 0)", a.style.whiteSpace = "pre", a.style.webkitUserSelect = "text", a.style.MozUserSelect = "text", a.style.msUserSelect = "text", a.style.userSelect = "text", a.addEventListener("copy", function(p) {
      if (p.stopPropagation(), t.format)
        if (p.preventDefault(), typeof p.clipboardData > "u") {
          o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var v = et[t.format] || et.default;
          window.clipboardData.setData(v, e);
        } else
          p.clipboardData.clearData(), p.clipboardData.setData(t.format, e);
      t.onCopy && (p.preventDefault(), t.onCopy(p.clipboardData));
    }), document.body.appendChild(a), c.selectNodeContents(a), y.addRange(c);
    var w = document.execCommand("copy");
    if (!w)
      throw new Error("copy command was unsuccessful");
    d = !0;
  } catch (p) {
    o && console.error("unable to copy using execCommand: ", p), o && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), d = !0;
    } catch (v) {
      o && console.error("unable to copy using clipboardData: ", v), o && console.error("falling back to prompt"), r = Wt("message" in t ? t.message : Bt), window.prompt(r, e);
    }
  } finally {
    y && (typeof y.removeRange == "function" ? y.removeRange(c) : y.removeAllRanges()), a && document.body.removeChild(a), i();
  }
  return d;
}
var Gt = Ht;
function Ge(e) {
  "@babel/helpers - typeof";
  return Ge = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ge(e);
}
Object.defineProperty(Pe, "__esModule", {
  value: !0
});
Pe.CopyToClipboard = void 0;
var Re = it(V), $t = it(Gt), Yt = ["text", "onCopy", "options", "children"];
function it(e) {
  return e && e.__esModule ? e : { default: e };
}
function tt(e, t) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), o.push.apply(o, r);
  }
  return o;
}
function rt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tt(Object(o), !0).forEach(function(r) {
      Ze(e, r, o[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : tt(Object(o)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(o, r));
    });
  }
  return e;
}
function Zt(e, t) {
  if (e == null)
    return {};
  var o = Ut(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    for (i = 0; i < c.length; i++)
      r = c[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
  }
  return o;
}
function Ut(e, t) {
  if (e == null)
    return {};
  var o = {}, r = Object.keys(e), i, c;
  for (c = 0; c < r.length; c++)
    i = r[c], !(t.indexOf(i) >= 0) && (o[i] = e[i]);
  return o;
}
function Jt(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ot(e, t) {
  for (var o = 0; o < t.length; o++) {
    var r = t[o];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Qt(e, t, o) {
  return t && ot(e.prototype, t), o && ot(e, o), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Xt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $e(e, t);
}
function $e(e, t) {
  return $e = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, $e(e, t);
}
function Ft(e) {
  var t = Kt();
  return function() {
    var r = ke(e), i;
    if (t) {
      var c = ke(this).constructor;
      i = Reflect.construct(r, arguments, c);
    } else
      i = r.apply(this, arguments);
    return qt(this, i);
  };
}
function qt(e, t) {
  if (t && (Ge(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return at(e);
}
function at(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Kt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ke(e) {
  return ke = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, ke(e);
}
function Ze(e, t, o) {
  return t in e ? Object.defineProperty(e, t, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = o, e;
}
var ct = /* @__PURE__ */ function(e) {
  Xt(o, e);
  var t = Ft(o);
  function o() {
    var r;
    Jt(this, o);
    for (var i = arguments.length, c = new Array(i), y = 0; y < i; y++)
      c[y] = arguments[y];
    return r = t.call.apply(t, [this].concat(c)), Ze(at(r), "onClick", function(a) {
      var d = r.props, w = d.text, p = d.onCopy, v = d.children, x = d.options, _ = Re.default.Children.only(v), h = (0, $t.default)(w, x);
      p && p(w, h), _ && _.props && typeof _.props.onClick == "function" && _.props.onClick(a);
    }), r;
  }
  return Qt(o, [{
    key: "render",
    value: function() {
      var i = this.props;
      i.text, i.onCopy, i.options;
      var c = i.children, y = Zt(i, Yt), a = Re.default.Children.only(c);
      return /* @__PURE__ */ Re.default.cloneElement(a, rt(rt({}, y), {}, {
        onClick: this.onClick
      }));
    }
  }]), o;
}(Re.default.PureComponent);
Pe.CopyToClipboard = ct;
Ze(ct, "defaultProps", {
  onCopy: void 0,
  options: void 0
});
var Vt = Pe, Ye = Vt.CopyToClipboard;
Ye.CopyToClipboard = Ye;
var nt = Ye;
const er = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgMjU2IDI1NiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CiAgPGcgc3R5bGU9InN0cm9rZTogbm9uZTsgc3Ryb2tlLXdpZHRoOiAwOyBzdHJva2UtZGFzaGFycmF5OiBub25lOyBzdHJva2UtbGluZWNhcDogYnV0dDsgc3Ryb2tlLWxpbmVqb2luOiBtaXRlcjsgc3Ryb2tlLW1pdGVybGltaXQ6IDEwOyBmaWxsOiBub25lOyBmaWxsLXJ1bGU6IG5vbnplcm87IG9wYWNpdHk6IDE7IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjQwNjU5MzQwNjU5MzQwMTYgMS40MDY1OTM0MDY1OTM0MDE2KSBzY2FsZSgyLjgxIDIuODEpIiA+CiAgICA8cGF0aCBkPSJNIDMyLjI4MyA4MC4yNSBjIC0wLjAxMyAwIC0wLjAyNiAwIC0wLjAzOSAwIGMgLTEuNzMzIC0wLjAxMiAtMy4zNzYgLTAuNzcxIC00LjUwNyAtMi4wODUgTCAxLjQ1NCA0Ny42NDQgYyAtMi4xNjMgLTIuNTExIC0xLjg4IC02LjMgMC42MzEgLTguNDYyIGMgMi41MTEgLTIuMTY0IDYuMjk5IC0xLjg4IDguNDYxIDAuNjMxIGwgMjEuNzk2IDI1LjMxMSBsIDQ3LjE2MyAtNTMuMzQ4IGMgMi4xOTQgLTIuNDg0IDUuOTg4IC0yLjcxNiA4LjQ2OSAtMC41MjEgYyAyLjQ4MyAyLjE5NSAyLjcxNyA1Ljk4NiAwLjUyMSA4LjQ2OSBsIC01MS43MTcgNTguNSBDIDM1LjYzOSA3OS41MTMgMzQuMDAxIDgwLjI1IDMyLjI4MyA4MC4yNSB6IiBzdHlsZT0ic3Ryb2tlOiBub25lOyBzdHJva2Utd2lkdGg6IDE7IHN0cm9rZS1kYXNoYXJyYXk6IG5vbmU7IHN0cm9rZS1saW5lY2FwOiBidXR0OyBzdHJva2UtbGluZWpvaW46IG1pdGVyOyBzdHJva2UtbWl0ZXJsaW1pdDogMTA7IGZpbGw6IHJnYigyNTUsMjU1LDI1NSk7IGZpbGwtcnVsZTogbm9uemVybzsgb3BhY2l0eTogMTsiIHRyYW5zZm9ybT0iIG1hdHJpeCgxIDAgMCAxIDAgMCkgIiBzdHJva2UtbGluZWNhcD0icm91bmQiIC8+CiAgPC9nPgo8L3N2Zz4K", tr = yt(
  "z-[999999] text-[13px] font-normal text-center shadow-md opacity-1 max-w-[320px] whitespace-normal",
  {
    variants: {
      variant: {
        default: "bg-slate-500 text-white whitespace-normal",
        success: "bg-green-500 text-white whitespace-nowrap"
      },
      small: {
        true: "rounded-[0.25rem] py-[0.25rem] px-[0.5rem] ",
        false: "rounded-[0.5rem] py-[0.5rem] px-[0.75rem] "
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), sr = ({ small: e, className: t, onlyCopyIcon: o, isOutside: r, place: i, noArrow: c, tooltipText: y, copiedText: a, name: d, children: w, onCopy: p }) => {
  const [v, x] = b(!1), [_, h] = b(!1), j = gt(), B = async () => {
    a && p && p(), a && !v && _ && (x(!0), await new Promise((g) => setTimeout(g, 550)), h(!1), await new Promise((g) => setTimeout(g, 100)), x(!1));
  }, M = async () => {
    a && p && p(), a && (v || (h(!0), x(!0), await new Promise((g) => setTimeout(g, 1e3)), h(!1), await new Promise((g) => setTimeout(g, 1e3)), x(!1)));
  }, A = {
    disableStyleInjection: !0,
    id: d,
    noArrow: e ? !0 : c,
    place: i,
    float: !1,
    offset: e ? 4 : 10,
    hidden: !y,
    className: tr({ small: !!e, variant: v ? "success" : "default" })
  };
  return /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    a ? j ? /* @__PURE__ */ E.jsx(nt.CopyToClipboard, { text: a || "", onCopy: B, children: /* @__PURE__ */ E.jsx(
      "span",
      {
        "data-tooltip-id": d,
        className: "select-none cursor-pointer " + t,
        onClick: () => {
          M();
        },
        children: o ? /* @__PURE__ */ E.jsx(We, {}) : w || a
      }
    ) }) : /* @__PURE__ */ E.jsx(nt.CopyToClipboard, { text: a || "", onCopy: B, children: /* @__PURE__ */ E.jsx(
      "span",
      {
        "data-tooltip-id": d,
        className: "select-none cursor-pointer " + t,
        onMouseEnter: () => {
          v || h(!0);
        },
        onMouseLeave: () => {
          v || h(!1);
        },
        children: o ? /* @__PURE__ */ E.jsx(We, {}) : w || a
      }
    ) }) : r ? null : /* @__PURE__ */ E.jsx(
      "span",
      {
        "data-tooltip-id": d,
        className: "select-none cursor-pointer " + t,
        onMouseEnter: () => h(!0),
        onMouseLeave: () => h(!1),
        children: o ? /* @__PURE__ */ E.jsx(We, {}) : w || a
      }
    ),
    /* @__PURE__ */ E.jsx(kt, { isOpen: r ? void 0 : _, ...A, children: /* @__PURE__ */ E.jsx(E.Fragment, { children: v ? /* @__PURE__ */ E.jsxs("span", { className: "!text-white flex items-center", style: { fontSize: 13 }, children: [
      /* @__PURE__ */ E.jsx("img", { src: er, style: { width: 12, height: 12, marginRight: 6 }, alt: "" }),
      " Copied"
    ] }) : y }) })
  ] });
};
export {
  sr as Tooltip
};
